export default __webpack_public_path__ + "static/media/85.f0bb0f6e.jpg";